import {
  CardContent,
  CardHeader,
  CardTitle,
  H2,
  SPARK_COLOURS,
} from "@motleyhand/design"
import { useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"
import { getStories } from "./stories"
import { CardLink } from "@/base"
import { Markdown } from "@/ui"

export default function StoriesPage() {
  const stories = getStories()
  const navigate = useNavigate()

  useEffect(() => {
    if (!stories.length) {
      void navigate({ to: "/" })
    }
  }, [stories, navigate])

  return (
    <div className="mx-auto flex max-w-[65ch] flex-col gap-8 py-12">
      {stories.map((story, i) => (
        <CardLink
          key={story.slug}
          spark={{
            colour: SPARK_COLOURS[i % SPARK_COLOURS.length] ?? "orange",
          }}
          to="/stories/$slug"
          params={{ slug: story.slug }}
        >
          <CardHeader>
            <CardTitle>
              <H2>{story.title}</H2>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <Markdown>{story.lead}</Markdown>
          </CardContent>
        </CardLink>
      ))}
    </div>
  )
}
